module.exports = __webpack_public_path__ + "img/icon_invoice_active.e3ae7955.png";